import {
  paymentStoreSelector,
  usePaymentStore,
} from '../../../stores/paymentStore';
import RemoteDataStatus from '../../../types/RemoteDataStatus';

const usePaymentStatus = (): Record<'loading' | 'error', boolean> => {
  const status = usePaymentStore(paymentStoreSelector.status);

  return {
    loading: status === RemoteDataStatus.Loading,
    error: status === RemoteDataStatus.Error,
  };
};

export default usePaymentStatus;
